import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Palette, Save } from 'lucide-react';

const AppearanceSettings = () => {
  const { api } = useAuth();
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState({
    primary_color: '#f59e0b', secondary_color: '#ef4444',
    background_color: '#0a0a12', text_color: '#e8e8f0',
    font_family: 'Inter', logo_url: '', favicon_url: ''
  });

  useEffect(() => {
    api.get('/admin/theme').then(r => setForm(r.data)).catch(console.error);
  }, []);

  const handleSave = async () => {
    setSaving(true); setMsg('');
    try {
      const { _id, ...data } = form;
      await api.put('/admin/theme', data);
      setMsg('Theme saved! Refresh website to see changes.');
    } catch (err) { setMsg('Error saving'); }
    setSaving(false);
  };

  const handleLogoUpload = async (e, field) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append('file', file);
    try {
      const res = await api.post('/admin/upload/banner', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setForm(prev => ({ ...prev, [field]: res.data.url }));
    } catch (err) { alert('Upload failed'); }
  };

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2 className="section-title"><Palette size={20} /> Appearance</h2>
        <button className="btn-primary" onClick={handleSave} disabled={saving}>
          <Save size={16} /> {saving ? 'Saving...' : 'Save Theme'}
        </button>
      </div>
      {msg && <div className="form-msg" style={{ marginBottom: 16 }}>{msg}</div>}

      <div className="two-col">
        <div className="admin-card">
          <h3 className="card-subtitle">Colors</h3>
          {[
            { key: 'primary_color', label: 'Primary Color (accent)' },
            { key: 'secondary_color', label: 'Secondary Color' },
            { key: 'background_color', label: 'Background Color' },
            { key: 'text_color', label: 'Text Color' },
          ].map(c => (
            <div key={c.key} className="color-row">
              <input type="color" value={form[c.key] || '#000000'} onChange={e => setForm({...form, [c.key]: e.target.value})}
                style={{ width: 40, height: 40, border: 'none', borderRadius: 8, cursor: 'pointer', background: 'transparent' }} />
              <div style={{ flex: 1 }}>
                <label className="form-label" style={{ margin: 0 }}>{c.label}</label>
                <input className="form-input" value={form[c.key] || ''} onChange={e => setForm({...form, [c.key]: e.target.value})}
                  style={{ marginTop: 4, fontFamily: 'monospace', fontSize: 12 }} />
              </div>
            </div>
          ))}
        </div>

        <div className="admin-card">
          <h3 className="card-subtitle">Branding</h3>
          <label className="form-label">Font Family</label>
          <select className="form-select" value={form.font_family} onChange={e => setForm({...form, font_family: e.target.value})}>
            {['Inter', 'Roboto', 'Open Sans', 'Poppins', 'Montserrat', 'Arial'].map(f => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>

          <label className="form-label" style={{ marginTop: 16 }}>Logo</label>
          <input type="file" accept="image/*" onChange={e => handleLogoUpload(e, 'logo_url')} className="form-input" />
          {form.logo_url && <img src={form.logo_url} alt="Logo" style={{ height: 40, marginTop: 8, borderRadius: 4 }} />}

          <label className="form-label" style={{ marginTop: 16 }}>Favicon</label>
          <input type="file" accept="image/*" onChange={e => handleLogoUpload(e, 'favicon_url')} className="form-input" />
          {form.favicon_url && <img src={form.favicon_url} alt="Favicon" style={{ height: 32, marginTop: 8, borderRadius: 4 }} />}

          <div style={{ marginTop: 20, padding: 16, borderRadius: 10, background: form.background_color, border: '1px solid rgba(255,255,255,0.06)' }}>
            <p style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>Preview</p>
            <p style={{ color: form.text_color, fontFamily: form.font_family, fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
              <span style={{ color: form.primary_color }}>Raja</span> Bokep
            </p>
            <p style={{ color: form.text_color, fontFamily: form.font_family, fontSize: 12, opacity: 0.6 }}>Sample text in {form.font_family}</p>
            <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
              <div style={{ width: 60, height: 24, borderRadius: 4, background: form.primary_color }} />
              <div style={{ width: 60, height: 24, borderRadius: 4, background: form.secondary_color }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppearanceSettings;
